import React from "react";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/lib/styles.scss";
import { CreditCardTemplate } from "js/components/Memberships/types";

const CreditCard: React.FC<CreditCardTemplate> = ({
  number,
  expiry = "****",
  cvc = "***",
  name = "***** *****",
  brand,
  preview = false,
  focus,
}) => {
  return (
    <>
      <Cards
        number={number}
        expiry={expiry}
        cvc={cvc}
        name={name}
        preview={preview}
        issuer={brand}
        focused={focus}
        // acceptedCards={["visa", "mastercard", "american-express"]}
      />
    </>
  );
};
export default CreditCard;
